import React, { Component } from 'react';
import { connect } from 'react-redux';
import {

    setPlayerRecomendationKey,
    showPlayerRecomMobPopUp,
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    playerRecomendationToggleAction,
    showHidePlayerRecomendationPopUpMob
} from './../../../actions/FormationActions';
import OutsideNotifier from '../../../OutsideNotifier';
import common from '../../../common';
import config from './../../../config';


class PlayerRecomendationMobileFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dropDownActive: false
        }
    }

    selectSugestion = (e, obj) => {
        //
        e.stopPropagation();
        if (this.props.playerRecomendedSelectedKey == obj.Key) {

        } else {
            this.props.setPlayerRecomendationKey(obj);
            common.customTracking('Select Player Recomendation Filter - ' + (config.playerRecomendationTrans[obj.Key] ? config.playerRecomendationTrans[obj.Key] : obj.Key), common.getPageName());

        }
        this.props.playerRecomendationToggleAction(false);
    }

    toggleDrpDownMob(e, val) {


        if (this.props.IsFirstTimeRecomend) {
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUp(true);
            common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
        } else {
            if (val == false) {
                e.stopPropagation();
                this.props.playerRecomendationToggleAction(false);
            } else {
                this.props.playerRecomendationToggleAction(true);
                common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
            }
        }


    }

    resetPlayerRecomendation(e) {
        e.stopPropagation();
        var obj = {
            Key: "playerRecomendationdDefault",
        }
        this.props.setPlayerRecomendationKey(obj);
    }

    openFirstTimePopUp() {
        if (this.props.IsFirstTimeRecomend) {
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUpMob(true);
            common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
        } else {
            this.props.showHidePlayerRecomendationPopUpMob(true);
            common.customTracking('Select Player Recomendation Filter - Filters', common.getPageName());
        }

    }




    render() {
        let trans = this.props.trans;
        const className = common.makeClasses({
            'si-selectBoxes': true,
            'si-active': this.props.playerRecomendationToggle,
        })

        const classToSearchOpen = common.makeClasses({
            'si-filter-types': true,
            'si-filter-suggest': true,
        })

        const classForSelected = common.makeClasses({
            "si-dropdown-btn": true,
            "si-flexBox": true,
            "si-selected-option": this.props.playerRecomendedSelectedKey.toLowerCase() != "playerrecomendationddefault"
        })
        return <div className="si-transfer-filter si-more-filters">

            <div className={ classToSearchOpen } >
                <div className="si-suggest-top">
                    <div className="si-suggest-wrp">
                        <span className="si-suggest si-flexBox">{ trans[this.props.playerRecomendedSelectedKey] ? trans[this.props.playerRecomendedSelectedKey] : 'transfer suggestions' }</span>
                        { this.props.IsFirstTimeRecomend ? <span className="si-suggest-new si-flexBox">{ trans.new ? trans.new : "New" }</span> : null }
                    </div>
                    <div className="si-icon-wrap" onClick={ () => { this.openFirstTimePopUp() } }>
                        <i className="icon-ucl-info"></i>
                    </div>
                </div>
                <div className="si-dropdown-wrap" onClick={ () => { this.toggleDrpDownMob(null, null) } }>
                    <div className={ className }>
                        { this.props.playerRecomendationToggle ? <div className="si-hidden-ctn" onClick={ (e) => this.toggleDrpDownMob(e, false) }></div> : null }
                        <div className={ classForSelected }>
                            <span >{ trans[this.props.playerRecomendedSelectedKey] ? trans[this.props.playerRecomendedSelectedKey] : this.props.playerRecomendedSelectedKey }</span>
                            { this.props.playerRecomendedSelectedKey.toLowerCase() == "playerrecomendationddefault" ? null : <span className="si-close" onClick={ (e) => { this.resetPlayerRecomendation(e) } }>
                                <i className="icon-ucl-close"></i>
                            </span> }
                            <i className="icon-ucl-position"></i>
                        </div>
                        { this.props.playerRecomendationToggle ? <OutsideNotifier
                            handler={ (e) => this.toggleDrpDownMob(e, false) }> <ul style={ common.setDropDownHeight("#playerRecomendationDropDownMobFilter", 34, this.props.playerRecomendationKeys.length) } className="si-dropdown-options" id="playerRecomendationDropDownMobFilter">
                                { this.props.playerRecomendationKeys.map((obj) => {
                                    const className = common.makeClasses({
                                        'si-active': obj.Key == this.props.playerRecomendedSelectedKey
                                    })
                                    return <li className={ className } key={ obj.Key } onClick={ (e) => { this.selectSugestion(e, obj) } }>
                                        <span>{ trans[obj.Key] ? trans[obj.Key] : obj.Key }</span>
                                    </li>
                                }) }
                            </ul></OutsideNotifier> : null }
                    </div>
                </div>
            </div >
        </div >
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerRecomendationKeys: state.formationData.playerRecomendationKeys,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend,
        playerRecomendationToggle: state.formationData.playerRecomendationToggle
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPlayerRecomendationKey: (obj) => dispatch(setPlayerRecomendationKey(obj)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool)),
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        playerRecomendationToggleAction: (bool) => dispatch(playerRecomendationToggleAction(bool)),
        showHidePlayerRecomendationPopUpMob: (bool) => dispatch(showHidePlayerRecomendationPopUpMob(bool))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerRecomendationMobileFilter);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerRecomendationMobileFilter.js